/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum Attendance {
  WORK = 'WORK',
  NOT_WORK = 'NOT_WORK',
  PENDING = 'PENDING',
}
